/* Web3Forms delivery for in-app feedback, sharing the inbox and access key
 * with the public contact form on the landing site.
 *
 * The access key is a public, per-form identifier by design: Web3Forms expects
 * it in client side code and it only allows posting to this one inbox.
 */
export const WEB3FORMS_KEY =
  process.env.REACT_APP_WEB3FORMS_KEY || "fb798227-b455-4841-a004-b4f589ce50a6";

export const WEB3FORMS_ENDPOINT = "https://api.web3forms.com/submit";

/**
 * Posts fields to Web3Forms. `meta` sets the envelope: subject line, sender
 * name, and the reply-to address so a reply reaches the person who wrote in.
 * Returns { ok, message }.
 */
export async function submitToWeb3Forms(fields, meta = {}) {
  const formData = new FormData();
  formData.append("access_key", WEB3FORMS_KEY);
  for (const [k, v] of Object.entries({ ...fields, ...meta })) {
    if (v) formData.append(k, v);
  }
  try {
    const res = await fetch(WEB3FORMS_ENDPOINT, { method: "POST", body: formData });
    const data = await res.json();
    return data.success
      ? { ok: true, message: data.message || "Sent" }
      : { ok: false, message: data.message || "The message could not be sent." };
  } catch {
    return { ok: false, message: "The message could not be sent. Check your connection and try again." };
  }
}
